
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.681 11.159c-.694-.947-1.662-2.053-2.724-3.116s-2.169-2.03-3.116-2.724C21.229 4.137 20.448 4 20 4H8.5A2.503 2.503 0 006 6.5v23C6 30.878 7.121 32 8.5 32h19c1.378 0 2.5-1.122 2.5-2.5V14c0-.448-.137-1.23-1.319-2.841zm-4.138-1.702A27.334 27.334 0 0126.811 12H22V7.189a27.334 27.334 0 012.543 2.268zM28 29.5c0 .271-.229.5-.5.5h-19a.507.507 0 01-.5-.5v-23c0-.271.229-.5.5-.5H20v7a1 1 0 001 1h7v15.5z"}}),_c('path',{attrs:{"d":"M18.841 1.319C17.229.137 16.448 0 16 0H4.5A2.503 2.503 0 002 2.5v23c0 1.207.86 2.217 2 2.45V2.5c0-.271.229-.5.5-.5h15.215a19.873 19.873 0 00-.873-.681z"}})])
          )
        }
      }
    